import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postJobRates({ body }) {
  return BaseService.post(REST.JOB_RATES, body);
}

function putJobRates({ body, id }) {
  return BaseService.put(REST.JOB_RATES_ID(id), body);
}

function getJobRates(params) {
  return BaseService.get(REST.JOB_RATES, {
    params: paramsFilter({ params }),
  });
}

function deleteJobRates({ id }) {
  return BaseService.delete(REST.JOB_RATES_ID(id));
}

export default {
  getJobRates,
  deleteJobRates,
  postJobRates,
  putJobRates,
};
